module.exports = __webpack_public_path__ + "static/media/openhihat.1dcc600a.wav";